import { Typography } from "@mui/material";
import { ReactNode } from "react";

export default function FieldsetForm({ title, children }: { title: string, children: ReactNode }) {
    return <fieldset>
        <Typography component={'legend'} variant='body1' sx={{ margin: 'auto' }} >{title}</Typography>
        {children}
    </fieldset>
}